import { Footer } from "../components/Footer"
import { PriorityMethods } from "../components/deposit/PriorityMethods"
import { AeropayMethods } from "../components/deposit/AeropayMethods"


export const DepositAeropayPage = () => {
    return (
        <div className="container">
            <PriorityMethods />
            <AeropayMethods />
            <Footer />
        </div>
    );
}